import script from "./Booking.vue?vue&type=script&setup=true&lang=ts"
export * from "./Booking.vue?vue&type=script&setup=true&lang=ts"

import "./Booking.vue?vue&type=style&index=0&id=0daba776&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0daba776"]])

export default __exports__